import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';

const MessageSeparator = ({ date, isNewMessage }) => {
  if (date && isNewMessage) {
    return (
      <div className="message-separator new-message-separator">
        <span className="date-separator-content date-separator-content-non-mobile">{getDisplayDate(date)}</span>
        <span className="date-separator-content date-separator-content-mobile">{getDisplayDate(date, 'ddd, MMM Do')}</span>
        <span className="new-message-separator-content">New Message</span>
      </div>
    );
  } else if (date) {
    return (
      <div className="message-separator date-separator">
        <span className="date-separator-content">{getDisplayDate(date)}</span>
      </div>
    );
  } else if (isNewMessage) {
    return (
      <div className="message-separator new-message-separator">
        <span className="new-message-separator-content">New Message</span>
      </div>
    );
  } else {
    return null;
  }
};

const getDisplayDate = (date, format) => moment(date).format(format || 'dddd, MMMM Do');

MessageSeparator.propTypes = {
  date: PropTypes.string,
  isNewMessage: PropTypes.bool
};

export default MessageSeparator;
